// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___Te4u","label":"styles_label__17RXC"};